import { punctualityService } from '../_services';

const state = { onRequest: false, punctuality: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        punctualityService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  punctuality: state => {
    return state.punctuality
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.punctuality = {};
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.punctuality = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.punctuality = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const punctualities = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
